var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288.813,
    height: 212.432,
    viewBox: "0 0 76.415 56.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3867.083h7377.615V0H0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.256 2.256 0 0 1-.417-1.687c.308-2.037.606-4.223.886-6.498a2.26 2.26 0 0 1 2.243-1.998c.113 0 .233.006.346.012 1.171.149 2.059 1.282 1.91 2.523v.001a201.006 201.006 0 0 1-.905 6.635C3.898.087 2.88.912 1.763.912c-.098 0-.196-.006-.293-.019A2.24 2.24 0 0 1 0 0",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 31.198 13.168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.33-.28 4.457-.565 6.5-.873a2.28 2.28 0 0 1 2.582 1.911 2.269 2.269 0 0 1-1.906 2.576c-2.269.337-4.44.628-6.637.892a2.23 2.23 0 0 1-.23.012c-1.145 0-2.155-.853-2.292-1.996A2.27 2.27 0 0 1 0 0",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 39.818 24.564)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.28 2.28 0 0 1-1.973 2.53 2.326 2.326 0 0 1-.235.012c-1.138 0-2.161-.866-2.296-1.995a215.48 215.48 0 0 0-.888-6.498 2.271 2.271 0 0 1 1.897-2.585c1.263-.201 2.401.689 2.593 1.899C-.581-4.559-.277-2.324 0 0",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 32.96 41.716)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.243 2.243 0 0 1-.414-1.683 2.26 2.26 0 0 1 2.586-1.902c1.97.304 4.095.592 6.498.88a2.257 2.257 0 0 1 1.516.851 2.25 2.25 0 0 1 .467 1.668 2.288 2.288 0 0 1-.882 1.539 2.199 2.199 0 0 1-1.627.449c-2.38-.289-4.616-.594-6.656-.906A2.246 2.246 0 0 1 0 0",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 11.293 23.616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.27 2.27 0 0 1-1.459-2.852c.381-1.167 1.695-1.851 2.852-1.463a90.886 90.886 0 0 0 6.222 1.742A2.27 2.27 0 0 1 9.279.167a2.256 2.256 0 0 1-1.035 1.402 2.244 2.244 0 0 1-1.7.262A94.804 94.804 0 0 1 0 0",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 4.849 24.842)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.149-2.043.284-4.25.4-6.562.031-.599.302-1.16.764-1.579l.173-.204c.418-.657 1.055-1.051 1.747-1.08a324.35 324.35 0 0 0 6.565-.393 2.26 2.26 0 0 1 2.422 2.09 2.279 2.279 0 0 1-2.1 2.431l-.003.001c-1.168.088-2.374.152-3.581.218l-1.546.084-.112 1.955A276.485 276.485 0 0 1 4.528.32c-.039.577-.343 1.147-.836 1.56-.417.349-.924.548-1.388.548-.056 0-.11-.002-.163-.008a2.278 2.278 0 0 1-1.6-.782A2.225 2.225 0 0 1 0 0",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 31.794 20.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-21.7-17.591-39.291-39.291-39.291-21.7 0-39.291 17.591-39.291 39.291 0 21.7 17.591 39.291 39.291 39.291C-17.591 39.291 0 21.7 0 0",
    style: {
      fill: "#163dfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 41.066 28.115)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.35278 0 0 -.35278 -437.68 381.114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0a90.509 90.509 0 0 1-6.549 1.816 2.445 2.445 0 0 1-.557.065c-1.038 0-1.931-.68-2.185-1.743a2.27 2.27 0 0 1 1.675-2.737 87.899 87.899 0 0 0 6.215-1.726c1.186-.378 2.482.304 2.861 1.473a2.248 2.248 0 0 1-.138 1.726C1.046-.586.577-.187 0 0",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1380.475 1009.957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-4.59-12.33-8.026-19.681-9.666h.001c-10.034-2.239-27.5-4.908-53.724-4.908-4.035 0-8.126.081-12.874.256l-1.391.05-.053 1.391c-.172 4.49-.256 8.703-.256 12.876 0 43.259 7.681 73.404 14.574 73.404l5.271-.264C-32.036 70.554-2.862 41.383-.272 5.284Zm-55.305-17.577.887.052c14.004.822 39.329 3.212 51.592 9.98l2.575 1.421-.362-2.919c-4.29-34.643-32.684-61.6-67.513-64.097l-5.278-.265c-6.846 0-12.502 27.444-14.015 53.976l-.096 1.65 1.652-.066c4.511-.176 8.703-.266 12.459-.266 3.746 0 7.933.09 12.446.266l1.105.044zm-27.141-55.215a73.204 73.204 0 0 0-63.749 63.75l-.363 2.919 2.576-1.422c12.276-6.778 37.626-9.162 51.643-9.98l1.332-.079.077-1.332c.82-14.015 3.204-39.362 9.982-51.643l1.42-2.573zM-146.543 5.29c2.497 34.829 29.453 63.217 64.097 67.501l2.918.36-1.42-2.574c-6.767-12.264-9.157-37.592-9.981-51.598l-.318-6.537a311.189 311.189 0 0 1-.268-12.443c0-3.764.09-7.955.268-12.458l.065-1.65-1.649.093c-26.533 1.514-53.978 7.17-53.978 14.015zM3.519-.363l-.02.242.036.245C3.504 42.448-31.009 76.94-73.404 76.94c-42.426 0-76.942-34.515-76.942-76.941 0-42.425 34.516-76.94 76.942-76.94 42.234 0 76.723 34.326 76.94 76.544z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1390.923 998.634)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.252 2.252 0 0 1-1.412 1.025h-.001A2.254 2.254 0 0 1-3.137.762 2.256 2.256 0 0 1-4.153-.646 87.969 87.969 0 0 0-5.88-6.878a2.243 2.243 0 0 1 .146-1.725 2.252 2.252 0 0 1 1.325-1.122c.211-.067.449-.102.688-.102a2.28 2.28 0 0 1 2.174 1.578A96.91 96.91 0 0 1 .262-1.717 2.252 2.252 0 0 1 0 0",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1330.39 943.943)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.624 2.538-1.223 4.678-1.829 6.54a2.279 2.279 0 0 1-2.857 1.462 2.246 2.246 0 0 1-1.317-1.12 2.256 2.256 0 0 1-.14-1.731 88.893 88.893 0 0 0 1.734-6.218c.287-1.204 1.554-1.94 2.757-1.67C-.46-2.448.288-1.219 0 0",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1330.62 1055.19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a7.104 7.104 0 0 0-7.105-7.104A7.103 7.103 0 0 0-14.209 0a7.103 7.103 0 0 0 7.104 7.104A7.104 7.104 0 0 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1376.855 1053.372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .393 9.319.056 1.342c.034.811-.714 1.5-1.5 1.5-.841 0-1.466-.687-1.5-1.5l-.393-9.319L-3 0c-.034-.811.714-1.5 1.5-1.5.841 0 1.466.688 1.5 1.5",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1374.78 1068.857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 8.791-1.513 1.269-.218c.798-.138 1.616.211 1.845 1.047.199.722-.245 1.707-1.047 1.845L2.067 2.675l-1.269.219C0 3.03-.818 2.681-1.048 1.846-1.246 1.124-.803.139 0 0",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1385.33 1053.791)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 9.493 10.989 1.357 1.571c.529.612.602 1.518 0 2.121-.542.541-1.59.616-2.122 0L-.765 3.691l-1.356-1.57c-.529-.612-.602-1.518 0-2.121C-1.58-.541-.532-.616 0 0",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1383.42 1062.642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.999 0 2.002 3.106 0 3.106C-1.999 3.106-2.002 0 0 0",
    style: {
      fill: "#163dfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1268.386 952.012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.999 0 2.002 3.106 0 3.106C-1.999 3.106-2.002 0 0 0",
    style: {
      fill: "#163dfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1256.106 952.012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.999 0 2.002 3.106 0 3.106C-1.999 3.106-2.002 0 0 0",
    style: {
      fill: "#163dfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1243.825 952.012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.999 0 2.002 3.106 0 3.106C-1.999 3.106-2.002 0 0 0",
    style: {
      fill: "#163dfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1268.386 961.925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.999 0 2.002 3.106 0 3.106C-1.999 3.106-2.002 0 0 0",
    style: {
      fill: "#163dfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1256.106 961.925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.999 0 2.002 3.106 0 3.106C-1.999 3.106-2.002 0 0 0",
    style: {
      fill: "#163dfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1243.825 961.925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.999 0 2.002 3.106 0 3.106C-1.999 3.106-2.002 0 0 0",
    style: {
      fill: "#163dfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1268.386 942.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.999 0 2.002 3.106 0 3.106C-1.999 3.106-2.002 0 0 0",
    style: {
      fill: "#163dfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1256.106 942.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.999 0 2.002 3.106 0 3.106C-1.999 3.106-2.002 0 0 0",
    style: {
      fill: "#163dfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1243.825 942.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.999 0 2.002 3.106 0 3.106C-1.999 3.106-2.002 0 0 0",
    style: {
      fill: "#163dfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1268.386 932.187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.999 0 2.002 3.106 0 3.106C-1.999 3.106-2.002 0 0 0",
    style: {
      fill: "#163dfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1256.106 932.187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.999 0 2.002 3.106 0 3.106C-1.999 3.106-2.002 0 0 0",
    style: {
      fill: "#163dfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1243.825 932.187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 12.6 10.214 22.813 22.813 22.813C35.412 22.813 45.625 12.6 45.625 0c0-12.599-10.213-22.812-22.812-22.812C10.221-22.795.018-12.592 0 0m-2.684 0c0-14.081 11.415-25.496 25.497-25.496 14.081 0 25.496 11.415 25.496 25.496 0 14.082-11.415 25.497-25.496 25.497C8.737 25.484-2.671 14.076-2.684 0",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1408.877 1015.387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-5.462-4.584c-.603-.507-.561-1.606 0-2.121.642-.59 1.478-.541 2.122 0l5.461 4.584c.604.507.562 1.605 0 2.121C1.479.589.644.54 0 0",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1364.486 1060.511)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-5.461-4.585c-.604-.506-.562-1.605 0-2.121.641-.589 1.477-.54 2.121 0l5.461 4.585c.604.506.562 1.605 0 2.121C1.48.589.644.54 0 0",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1375.644 1051.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.592-.462 8.592-.462 12.592-.462 2 6 0 11 .687 17.494",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(1418.467 967.492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h9.569",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(1387.853 967.492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a5.336 5.336 0 0 1-3.785-1.565 5.319 5.319 0 0 1-1.569-3.787 5.32 5.32 0 0 1 1.569-3.786 5.326 5.326 0 0 1 3.786-1.568c1.429 0 2.774.558 3.786 1.568a5.363 5.363 0 0 1 0 7.573A5.337 5.337 0 0 1 0 0m.001-13.121a7.717 7.717 0 0 0-5.494 2.276 7.714 7.714 0 0 0-2.275 5.493c0 2.077.807 4.028 2.275 5.495 3.031 3.03 7.961 3.026 10.987 0 3.029-3.03 3.029-7.958 0-10.988a7.716 7.716 0 0 0-5.493-2.276",
    style: {
      fill: "#073ff5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1396.528 942.792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v5.046c0 .741-.601 1.342-1.342 1.342h-5.877l4.535 9.071v-5.045c0-.741.601-1.342 1.342-1.342h5.878Zm7.85 11.125a1.339 1.339 0 0 1-1.14.631H0v9.393a1.342 1.342 0 0 1-2.536.604L-10.588 5.65a1.342 1.342 0 0 1 1.195-1.946h6.709v-9.393c.002-.621.43-1.16 1.034-1.302.1-.027.204-.04.308-.04.506.002.967.287 1.195.738L7.904 9.81a1.35 1.35 0 0 1-.054 1.315",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1408.921 959.822)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a3.672 3.672 0 1 0-7.343.001A3.672 3.672 0 0 0 0 0",
    style: {
      fill: "#163dfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1372.632 1053.723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.889 3.437.352 7.085-1.403 10.366-.798 1.494-2.102 2.41-3.627 3.049-1.268.531-2.802.856-3.527 2.137-.795 1.399-1.228 2.803-2.587 3.786-1.078.778-2.374 1.079-3.676 1.215-2.258.235-5.532-.52-7.466.979-.644.5-1.49.617-2.121 0-.523-.511-.639-1.625 0-2.121 2.225-1.725 4.838-1.735 7.538-1.764 1.146-.011 2.435.022 3.507-.46 1.295-.583 1.572-2.018 2.214-3.15.789-1.39 2.017-2.181 3.459-2.776 1.228-.508 2.666-.85 3.459-2.009.838-1.226.926-2.828.93-4.263.007-1.955-.088-3.874.407-5.786C-2.41-2.665.485-1.873 0 0",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1430.95 995.485)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.495-3.196-3.143-6.362-.699-9.44 1.828-2.304 5.214-2.406 7.897-2.149-.483.366-.965.734-1.447 1.101.461-2.548-.074-5.159.314-7.722.299-1.979 1.136-3.864 2.336-5.462 2.421-3.224 6.12-5.275 10.171-5.401 1.931-.06 1.929 2.94 0 3-3.315.103-6.419 1.986-8.183 4.78C8.121-17.701 9.36-13.646 8.644-9.69c-.107.591-.84 1.159-1.446 1.101-1.621-.155-4.466-.471-5.601 1.048-.646.862-.274 2.002.048 2.911.452 1.276 1.039 2.483 1.248 3.832C3.185 1.091.295 1.905 0 0",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1433.72 1036.529)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.917a9e04c38dd45aa707e1ae4293c055.svg";
export { ForwardRef as ReactComponent };